<template>
  <div class="is-flex is-justify-content-center">
    <div class="columns is-align-items-end">
      <div class="column mx-4">
        <label>גורם מאשר:</label>
        <input type="text" class="input mb-3" v-model="confirm" />
        <button
          @click="onClose($attrs.payload.modal_id)"
          class="button is-info is-fullwidth"
          :disabled="confirm.length == 0" >
          קיבלתי אישור להארכה
        </button>
      </div>
      <div class="column has-text-centered">
        <button
          @click="onSubmit($attrs.payload.modal_id)"
          class="button is-info mx-3">
          סיימתי
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedAlertTimeLimit',
  props: {
    onSubmit: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      confirm: ''
    }
  }
}
</script>
